// extracted by mini-css-extract-plugin
export var checkbox = "_44-0";
export var circle = "_44-3";
export var horizontalContainer = "_44-7";
export var sm = "_44-5";
export var switch0 = "_44-2";
export var switchDisabled = "_44-8";
export var switchEnabled = "_44-1";
export var textSwitchContainer = "_44-9";
export var textSwitchOption = "_44-a";
export var textSwitchOptionSelected = "_44-b";
export var verticalContainer = "_44-6";
export var xs = "_44-4";